module.exports = __webpack_public_path__ + "static/media/box.eb49f3fd.svg";